import { render, staticRenderFns } from "./FormsSegregovaneKomunityPred.vue?vue&type=template&id=3116ab38&"
import script from "./FormsSegregovaneKomunityPred.vue?vue&type=script&lang=js&"
export * from "./FormsSegregovaneKomunityPred.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports